var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Alert } from '@material-ui/lab';
import React, { useContext, useEffect } from 'react';
import { MixpanelContext } from '../hooks/useMixpanel';
import { ContactInformationForm, stateRequiredForCountry, zipRequiredForCountry } from './ContactInformationForm';
var styles = makeStyles(function (theme) { return ({
    root: {
        margin: 0,
        padding: theme.spacing(2)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
    dialogAction: {
        padding: '16px'
    },
    dialogHeader: {
        fontSize: '16px 24px'
    },
    form: {
        position: 'relative'
    },
    progress: {
        color: 'white',
        marginRight: '16px'
    }
}); });
var blankFormErrorState = {
    errorCount: 0,
    email: '',
    company: '',
    firstName: '',
    lastName: '',
    phone: '',
    country: '',
    state: '',
    postalCode: ''
};
export function LicenseSummaryDialog(_a) {
    var licenseInfo = _a.licenseInfo, licenseRequestState = _a.licenseRequestState, onClose = _a.onClose, onLicensesRequestClick = _a.onLicensesRequestClick, _b = _a.open, open = _b === void 0 ? false : _b;
    var _c = __read(React.useState(blankFormErrorState), 2), formErrors = _c[0], setFormErrors = _c[1];
    var classes = styles();
    var _d = useContext(MixpanelContext), mixpanel = _d.mixpanel, productPrefix = _d.productPrefix;
    useEffect(function () {
        if (!open)
            return;
        mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.track("".concat(productPrefix, " Licenses review summary"));
    }, [mixpanel, open]);
    var handleClose = function () {
        setFormErrors(blankFormErrorState);
        onClose();
    };
    // const handleSubmit = e => {
    //   e.preventDefault()
    //   const formData = new FormData(e.target)
    //   const fe = JSON.parse(JSON.stringify(Object.fromEntries(formData)))
    //   const errors = validateForm(fe)
    //   setFormErrors(errors)
    //   if (errors.errorCount === 0) {
    //     onLicensesRequestClick(fe)
    //   }
    // }
    var handleSubmit = function (e) {
        e.preventDefault();
        var formData = new FormData(e.target);
        // Using `forEach` to iterate over FormData to avoid TS error
        var fe = {};
        formData.forEach(function (value, key) {
            fe[key] = value;
        });
        var errors = validateForm(fe);
        setFormErrors(errors);
        if (errors.errorCount === 0) {
            onLicensesRequestClick(fe);
        }
    };
    var ContactForm = (React.createElement(Dialog, { fullWidth: true, open: open, className: classes.root, maxWidth: "xs", onClose: handleClose },
        licenseRequestState.status === 'error' ? (React.createElement(Alert, { severity: "error" }, "Connection failed when requesting licenses. Please try again.")) : null,
        React.createElement("form", { onSubmit: handleSubmit, className: classes.form },
            React.createElement(DialogTitle, { disableTypography: true, className: classes.dialogHeader },
                React.createElement(Typography, { variant: "h2" }, "Contact information"),
                onClose ? (React.createElement(IconButton, { "aria-label": "close", className: classes.closeButton, onClick: function () {
                        onClose();
                    } },
                    React.createElement(CloseIcon, null))) : null),
            React.createElement(DialogContent, null,
                React.createElement(ContactInformationForm, { errors: formErrors }),
                React.createElement(Grid, { style: { margin: '16px 0' }, container: true },
                    React.createElement(Grid, { item: true, xs: 6, style: {
                            display: 'flex',
                            alignItems: 'center'
                        } },
                        React.createElement(Typography, { variant: "body1" }, "Additional licenses requested")),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(Typography, { variant: "h2", style: {
                                display: 'flex',
                                justifyContent: 'end'
                            } }, licenseInfo.unlicensedUsers.toLocaleString())))),
            React.createElement(DialogActions, { className: classes.dialogAction },
                React.createElement(Button, { "data-testid": "lcui-submit-lead-request-button", type: "submit", color: "primary", variant: "contained", disabled: licenseRequestState.status === 'loading' },
                    licenseRequestState.status === 'loading' ? (React.createElement(CircularProgress, { size: 16, className: classes.progress })) : null,
                    "Submit request")))));
    return ContactForm;
}
var WEB_TEAM_EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
var WEB_TEAM_PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
var WEB_COMPANY_REGEX = /[a-zA-z]+/i;
function validateForm(formData) {
    var errors = {
        errorCount: 0,
        email: '',
        company: '',
        firstName: '',
        lastName: '',
        phone: '',
        country: '',
        state: '',
        postalCode: ''
    };
    if (!formData.email) {
        errors.email = 'Email is a required field';
        errors.errorCount += 1;
    }
    else if (formData.email.match(WEB_TEAM_EMAIL_REGEX) === null) {
        errors.email = 'Email is invalid';
        errors.errorCount += 1;
    }
    if (!formData.company) {
        errors.company = 'Company name is a required field';
        errors.errorCount += 1;
    }
    else if (formData.company.match(WEB_COMPANY_REGEX) === null) {
        errors.company = 'Company name is invalid';
        errors.errorCount += 1;
    }
    if (!formData.firstName) {
        errors.firstName = 'First name is a required field';
        errors.errorCount += 1;
    }
    if (!formData.lastName) {
        errors.lastName = 'Last name is a required field';
        errors.errorCount += 1;
    }
    if (!formData.phone) {
        errors.phone = 'Phone number is a required field';
        errors.errorCount += 1;
    }
    else if (formData.phone.match(WEB_TEAM_PHONE_REGEX) === null) {
        errors.phone = 'Phone number is invalid';
        errors.errorCount += 1;
    }
    if (!formData.country) {
        errors.country = 'Country is a required field';
        errors.errorCount += 1;
    }
    if (!formData.state && stateRequiredForCountry(formData.country)) {
        errors.state = 'State or province is a required field';
        errors.errorCount += 1;
    }
    if (!formData.postalCode && zipRequiredForCountry(formData.country)) {
        errors.postalCode = 'Zip or postal code is a required field';
        errors.errorCount += 1;
    }
    return errors;
}
//# sourceMappingURL=SummaryDialog.js.map